var TuiEditorTool;
(function (TuiEditorTool) {
    TuiEditorTool["Undo"] = "undo";
    TuiEditorTool["Anchor"] = "anchor";
    TuiEditorTool["Size"] = "fontSize";
    TuiEditorTool["Bold"] = "bold";
    TuiEditorTool["Italic"] = "italic";
    TuiEditorTool["Underline"] = "underline";
    TuiEditorTool["Strikethrough"] = "strikeThrough";
    TuiEditorTool["Align"] = "justify";
    TuiEditorTool["List"] = "list";
    TuiEditorTool["Quote"] = "quote";
    TuiEditorTool["Color"] = "foreColor";
    TuiEditorTool["Hilite"] = "hiliteColor";
    TuiEditorTool["Clear"] = "clear";
    TuiEditorTool["Link"] = "link";
    TuiEditorTool["Attach"] = "attach";
    TuiEditorTool["Tex"] = "tex";
    TuiEditorTool["Code"] = "code";
    TuiEditorTool["Img"] = "image";
    TuiEditorTool["HR"] = "insertHorizontalRule";
    TuiEditorTool["Sup"] = "superscript";
    TuiEditorTool["Sub"] = "subscript";
    TuiEditorTool["Table"] = "insertTable";
    TuiEditorTool["MergeCells"] = "mergeCells";
    TuiEditorTool["SplitCells"] = "splitCells";
    TuiEditorTool["RowsColumnsManaging"] = "rowsColumnsManaging";
    TuiEditorTool["Details"] = "details";
    TuiEditorTool["Group"] = "group";
})(TuiEditorTool || (TuiEditorTool = {}));

/**
 * Generated bundle index. Do not edit.
 */

export { TuiEditorTool };
